import React, { FC } from 'react';

const AddressIcon: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.39582 13.4406H10.7987V10.1117H13.2013V13.4406H15.6042V7.70879L12 5.30622L8.39582 7.70879V13.4406ZM12 22.1431C14.5462 19.8637 16.4946 17.6774 17.8454 15.5842C19.1961 13.4909 19.8715 11.6575 19.8715 10.084C19.8715 7.71139 19.1177 5.76088 17.6101 4.23248C16.1025 2.70409 14.2325 1.93989 12 1.93989C9.76749 1.93989 7.89745 2.70409 6.38988 4.23248C4.88231 5.76088 4.12852 7.71139 4.12852 10.084C4.12852 11.6575 4.80389 13.4909 6.15463 15.5842C7.50537 17.6774 9.45383 19.8637 12 22.1431ZM12 24C11.7464 24 11.4928 23.9563 11.2393 23.8689C10.9855 23.7812 10.756 23.6457 10.5508 23.4622C9.3829 22.3858 8.28996 21.2774 7.27197 20.1368C6.2542 18.9965 5.3695 17.8565 4.61788 16.7168C3.86605 15.5771 3.27116 14.4475 2.8332 13.328C2.39525 12.2083 2.17627 11.127 2.17627 10.084C2.17627 7.0806 3.14773 4.64907 5.09066 2.78944C7.0338 0.929813 9.33691 0 12 0C14.6631 0 16.9662 0.929813 18.9093 2.78944C20.8523 4.64907 21.8237 7.0806 21.8237 10.084C21.8237 11.127 21.6047 12.2061 21.1668 13.3215C20.7288 14.4371 20.1361 15.5668 19.3886 16.7106C18.6409 17.8544 17.7582 18.9944 16.7404 20.1306C15.7226 21.2671 14.6297 22.3733 13.4616 23.4495C13.2564 23.633 13.0249 23.7706 12.7672 23.8624C12.5093 23.9541 12.2536 24 12 24Z"
        fill="#424140"
      />
    </svg>
  );
};

export default AddressIcon;
